import React, { useState, useEffect } from "react";

const TriggerModal = ({ fieldName, title, content, closeModal, saveField }) => {
    const [pairs, setPairs] = useState([{ helpsEnterFlow: "", howApply: "" }]);

    useEffect(() => {
        if (content) {
            try {
                const parsed = JSON.parse(content);
                if (Array.isArray(parsed) && parsed.length > 0) {
                    setPairs(parsed);
                }
            } catch (e) {
                // If content is not valid JSON, keep default empty pair
            }
        }
    }, [content]);

    const handleHelpsEnterFlowChange = (index, value) => {
        const newPairs = [...pairs];
        newPairs[index].helpsEnterFlow = value;
        setPairs(newPairs);
    };

    const handleHowApplyChange = (index, value) => {
        const newPairs = [...pairs];
        newPairs[index].howApply = value;
        setPairs(newPairs);
    };

    const addPair = () => {
        setPairs([...pairs, { helpsEnterFlow: "", howApply: "" }]);
    };

    const removePair = (index) => {
        const newPairs = pairs.filter((_, i) => i !== index);
        setPairs(newPairs);
    };

    const handleSave = () => {
        const dataToSave = JSON.stringify(pairs);
        saveField(dataToSave);
        closeModal();
    };

    return (
        <div className="modal fade show modal-overlay" style={{ display: "block" }}>
            <div className="modal-dialog modal-lg">
                <div className="modal-content">
                    <div className="modal-header">
                        <h4 className="modal-title">{title}</h4>
                        <button className="btn-close" type="button" aria-label="Close" onClick={closeModal}></button>
                    </div>
                    <div className="modal-body">
                        {pairs.map((pair, index) => (
                            <div key={index} className="mb-4 p-3 border rounded">
                                <div className="d-flex justify-content-between align-items-center mb-2">
                                    <h6>{title.charAt(0).toUpperCase() + title.slice(1).toLowerCase()} {index + 1}</h6>
                                    {pairs.length > 1 && (
                                        <button 
                                            className="btn btn-sm btn-danger" 
                                            onClick={() => removePair(index)}
                                        >
                                            Remove
                                        </button>
                                    )}
                                </div>
                                <div className="mb-2">
                                    <label className="font-weight-bold">What helps me enter flow:</label>
                                    <textarea
                                        className="form-control w-100"
                                        style={{ resize: "none", minHeight: "2em" }}
                                        value={pair.helpsEnterFlow}
                                        onChange={(e) => handleHelpsEnterFlowChange(index, e.target.value)}
                                        rows={2}
                                        placeholder="Enter what helps you enter flow..."
                                    />
                                </div>
                                <div>
                                    <label className="font-weight-bold">How I apply for it:</label>
                                    <textarea
                                        className="form-control w-100"
                                        style={{ resize: "none", minHeight: "2em" }}
                                        value={pair.howApply}
                                        onChange={(e) => handleHowApplyChange(index, e.target.value)}
                                        rows={2}
                                        placeholder="Enter how you apply for it..."
                                    />
                                </div>
                            </div>
                        ))}
                        <button 
                            className="btn btn-primary mt-2" 
                            onClick={addPair}
                        >
                            + Add Pair
                        </button>
                    </div>
                    <div className="modal-footer">
                        <button className="btn btn-light" type="button" onClick={closeModal}>
                            Close
                        </button>
                        <button className="btn btn-primary" type="button" onClick={handleSave}>
                            Save
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TriggerModal;
